import {Linkedin,Github,Link as LinkIcon} from 'lucide-react'



function IconDisplay({type}){

    if(type==='LinkedIn'){
        return  <Linkedin size={14} color="#0077b5" />
    }

    if(type==='GitHub'){
        return <Github  size={14} color="#0077b5" />
    }

    

    return <LinkIcon  size={14} color="#0077b5"/> 

}

export default IconDisplay